import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-7xl" }
const _hoisted_2 = { class: "mx-auto mt-10" }
const _hoisted_3 = { class: "flex flex-wrap justify-center gap-6 md:gap-8 lg:gap-10" }
const _hoisted_4 = ["src", "alt"]

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import type { LogosBaseProps } from "./logos.interface";
import SectionContainer from "@/views/blocks/shared/section/container/SectionContainer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleWithHeading',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionContainer, {
    id: _ctx.block.webId,
    class: "lg:px-8 px-6",
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!dataValues.value.title.isHidden)
          ? (_openBlock(), _createBlock(EditableElement, {
              key: 0,
              blockId: _ctx.block.id,
              fieldName: "title"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.block.dataValues.title.data.tag), {
                  class: "text-center text-lg/8 font-semibold",
                  style: _normalizeStyle({
                        color: styleValues.value.text,
                    })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(dataValues.value.title.data.text), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              ]),
              _: 1
            }, 8, ["blockId"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.logos.data.items, (logo) => {
              return (_openBlock(), _createBlock(EditableElement, {
                key: logo.id,
                blockId: _ctx.block.id,
                fieldName: `logos_${logo.id}`,
                hideable: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "h-8 w-32 md:h-10 md:w-40 lg:h-12 lg:w-[211px] object-contain",
                    src: logo.src,
                    alt: logo.alt,
                    width: "211",
                    height: "48"
                  }, null, 8, _hoisted_4)
                ]),
                _: 2
              }, 1032, ["blockId", "fieldName"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "backgroundColor"]))
}
}

})